import { Link, useNavigate, useLocation } from "react-router-dom";
import { NAV_LINKS } from "@/data/site";

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const go = (href) => {
    const id = href.replace("#", "");
    if (location.pathname === "/") {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(`/${href}`);
    }
  };

  return (
    <footer
      className="lx-noise relative border-t"
      style={{ borderColor: "var(--lx-border)", background: "rgba(11,15,12,0.6)" }}
    >
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <img
              src="/liberox-labs-alpha.png"
              alt="LiberoX Labs"
              className="h-12 w-auto"
              style={{ filter: "drop-shadow(0 0 12px rgba(168,232,92,0.22))" }}
            />
            <p className="mt-5 text-sm leading-relaxed text-[color:var(--lx-text-2)]">
              Premium App-Entwicklung. Eine Marke der Liberox GmbH. Wir bauen
              iOS-, Android- und Web-Apps mit Design-Exzellenz.
            </p>
            <div className="mt-5 flex items-center gap-2">
              <span
                className="h-2 w-2 rounded-full"
                style={{
                  background: "var(--lx-green)",
                  boxShadow: "0 0 10px rgba(168,232,92,0.6)",
                }}
              />
              <span className="font-mono-lx text-xs text-[color:var(--lx-text-2)]">
                Status: verfügbar für neue Projekte
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="lx-kicker mb-1">Navigation</div>
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                onClick={() => go(l.href)}
                className="text-left text-sm text-[color:var(--lx-text-2)] transition-colors hover:text-[color:var(--lx-text)]"
              >
                {l.label}
              </button>
            ))}
          </div>

          <div className="flex flex-col gap-3">
            <div className="lx-kicker mb-1">Rechtliches</div>
            <Link
              to="/impressum"
              className="text-sm text-[color:var(--lx-text-2)] transition-colors hover:text-[color:var(--lx-text)]"
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              className="text-sm text-[color:var(--lx-text-2)] transition-colors hover:text-[color:var(--lx-text)]"
            >
              Datenschutz
            </Link>
            <a
              href="mailto:labs@liberox.ch"
              className="text-sm text-[color:var(--lx-text-2)] transition-colors hover:text-[color:var(--lx-text)]"
            >
              labs@liberox.ch
            </a>
          </div>
        </div>

        <div
          className="mt-12 flex flex-col gap-3 border-t pt-6 sm:flex-row sm:items-center sm:justify-between"
          style={{ borderColor: "var(--lx-border)" }}
        >
          <p className="font-mono-lx text-xs text-[color:var(--lx-muted)]">
            © {new Date().getFullYear()} Liberox GmbH · LiberoX Labs. Alle Rechte vorbehalten.
          </p>
          <p className="font-mono-lx text-xs text-[color:var(--lx-muted)]">
            Made with care in Switzerland 🇭🇨
          </p>
        </div>
      </div>
    </footer>
  );
};
